import React from 'react';
import { FormattedMessage } from "react-intl";
import { Spinner } from "@lysaab/ui-2";
export const LysaManualReview = () => {
    return (React.createElement("div", { className: "pending-container" },
        React.createElement(Spinner, null),
        React.createElement("div", null,
            React.createElement(FormattedMessage, { id: "onfido.status.id.waiting_for_lysa_manual_review" }))));
};
